import React from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";
import Homepage from '../views/homepage'
import Event from '../views/event'
import DetailEvent from '../views/event/detail'
import Insight from '../views/insight'
import InsightDetail from '../views/insight/detail_insight'
import MeetingSchedule from '../views/meeting'
import EventManagement from '../views/event_management'
import Navbar from '../components/navbar'
import Contact from '../views/contact'
import Careers from '../views/careers'
import Aboutus from '../views/aboutus'
import Consulting from '../views/consulting'
import Learning from '../views/learning'
import Assesment from '../views/assesment'
import DigitalLearning from '../views/digital_learning'

import Strategy from '../views/consulting/strategy'
import System from '../views/consulting/system'
import People from '../views/consulting/people'
import Structur from '../views/consulting/structur'
import ChangeManagement from '../views/consulting/change_management'
import ItStrategic from '../views/consulting/it_strategic'

import Inhouse from '../views/learning/inhouse'
import Blended from '../views/learning/blended'
import Certification from '../views/learning/certification'
import Corporate from '../views/learning/corporate'

import Gallery from '../views/gallery'

import Artist from '../views/event_management/artist'
import CorporateMeeting from '../views/event_management/corporate_meeting'
import CustomerFamily from '../views/event_management/custome_family'
import MegaSeminar from '../views/event_management/mega_serminar'
import ProductLaunch from '../views/event_management/product_launch'
import Theme from '../views/event_management/theme'

import AssestmentCenter from '../views/assesment/assestment_center'
import Competency from '../views/assesment/competency'
import OnlinePsychologi from '../views/assesment/online_psychologi'
import PsychologicaTest from '../views/assesment/psychologica_test'
import VirtualAssestment from '../views/assesment/virtual_assestment'

import Content from '../views/digital_learning/content'
import Game from '../views/digital_learning/game'
import MobileLearning from '../views/digital_learning/mobile_learning'
import MotionGraphic from '../views/digital_learning/motion_graphic'
import Platform from '../views/digital_learning/platform'
import Workshops from '../views/digital_learning/workshops'

import WhitePaper from '../views/whitepaper'
import Booklist from '../views/booklist'
import Buletin from '../views/bulletin'

import WorkshopInyear from '../views/event/workshop_year'
import Navbar2 from '../components/navbar/navbar2'

import AuditDesktop from '../views/audit/desktop'
import Report from '../views/audit/report'

import Tdra from '../views/audit/tdra'
import TdraReport from '../views/audit/tdra/report'
import TdraReportIndividual from '../views/audit/tdra/report_individual'

import Lps from '../views/audit/lps'
import LpsReport from '../views/audit/lps/report'
import LpsReportIndividual from '../views/audit/lps/report_individual'

import Akhlak from '../views/audit/akhlak'
import AkhlakReport from '../views/audit/akhlak/report'
import AkhlakReportAll from '../views/audit/akhlak/report_all'

import Kepemimpinan from '../views/audit/kepemimpinan'
import KepemimpinanReport from '../views/audit/kepemimpinan/report'
import KepemimpinanReport2 from '../views/audit/kepemimpinan/report2'

import Catalouge from '../views/catalouge'
import NewDtra from '../views/audit/new-dtra';
import ReportEdtra from '../views/audit/new-dtra/report';
import ListLink from '../views/audit/new-dtra/ListLink';

export default function index() {
    return (
        <Router>
          <Switch>
            
            <Route  path="/navbar">
              <Navbar />
            </Route>
            
            <Route path='/' exact component={Homepage}/>
            <Route path='/navbar2' exact component={Navbar2}/>
            <Route path='/event-list' exact component={Event}/>
            <Route path='/event' exact component={Event}/>
            <Route path='/event-plan/:year' exact component={WorkshopInyear}/>
            <Route path='/insight' exact component={Insight}/>

            <Route path='/event-list/detail/:slug' exact component={DetailEvent}/>
            <Route path='/publication/insight/detail/:slug' exact component={InsightDetail}/>
            <Route path='/schedule' exact component={MeetingSchedule}/>
            <Route path='/contact' exact component={Contact}/>
            <Route path='/careers' exact component={Careers}/>
            <Route path='/about' exact component={Aboutus}/>


            <Route path='/services/eventmanagement' exact component={EventManagement}/>
            <Route path='/services/eventmanagement/megaseminar' exact component={MegaSeminar}/>
            <Route path='/services/eventmanagement/customerbuilding' exact component={CustomerFamily}/>
            <Route path='/services/eventmanagement/productlaunch' exact component={ProductLaunch}/>
            <Route path='/services/eventmanagement/corporatemeeting' exact component={CorporateMeeting}/>
            <Route path='/services/eventmanagement/artist' exact component={Artist}/>
            <Route path='/services/eventmanagement/themeevvent' exact component={Theme}/>

            <Route path='/services/consulting' exact component={Consulting}/>
            <Route path='/services/consulting/strategy' exact component={Strategy}/>
            <Route path='/services/consulting/structur' exact component={Structur}/>
            <Route path='/services/consulting/system' exact component={System}/>
            <Route path='/services/consulting/change' exact component={ChangeManagement}/>
            <Route path='/services/consulting/people' exact component={People}/>
            <Route path='/services/consulting/it' exact component={ItStrategic}/>

            <Route path='/services/learning' exact component={Learning}/>
            <Route path='/services/learning/blendedlearning' exact component={Blended}/>
            <Route path='/services/learning/certification' exact component={Certification}/>
            <Route path='/services/learning/corporate' exact component={Corporate}/>
            <Route path='/services/learning/inhouse' exact component={Inhouse}/>


            <Route path='/services/assesment' exact component={Assesment}/>
            <Route path='/services/assesment/virtualassestmment' exact component={VirtualAssestment}/>
            <Route path='/services/assesment/psychologi' exact component={PsychologicaTest}/>
            <Route path='/services/assesment/center' exact component={AssestmentCenter}/>
            <Route path='/services/assesment/onlinetest' exact component={OnlinePsychologi}/>
            <Route path='/services/assesment/compentency' exact component={Competency}/>

            <Route path='/services/digitallearning' exact component={DigitalLearning}/>
            <Route path='/services/digitallearning/platform' exact component={Platform}/>
            <Route path='/services/digitallearning/motiongraphic' exact component={MotionGraphic}/>
            <Route path='/services/digitallearning/mobilelearning' exact component={MobileLearning}/>
            <Route path='/services/digitallearning/content' exact component={Content}/>
            <Route path='/services/digitallearning/game' exact component={Game}/>
            <Route path='/services/digitallearning/workshops' exact component={Workshops}/>

            <Route path='/publication/gallery' exact component={Gallery}/>
            <Route path='/publication/whitepaper' exact component={WhitePaper}/>
            <Route path='/publication/booklist' exact component={Booklist}/>
            <Route path='/publication/bulletin' exact component={Buletin}/>

            <Route path='/organitationassessment' exact component={AuditDesktop}/>
            <Route path='/hrbp' exact component={AuditDesktop}/>

            <Route path='/digital-transformation-readiness-assessment' exact component={Tdra}/>
            <Route path='/digital-transformation-readiness-assessment/report' exact component={TdraReport}/>
            <Route path='/digital-transformation-readiness-assessment/report/:uuid' exact component={TdraReportIndividual}/>

            <Route path='/lps-digital-transformation-readiness-assessment' exact component={Lps}/>
            <Route path='/lps-digital-transformation-readiness-assessment/report' exact component={LpsReport}/>
            <Route path='/lps-digital-transformation-readiness-assessment/report/:uuid' exact component={LpsReportIndividual}/>

            <Route path='/akhlak' exact component={Akhlak}/>
            <Route path='/akhlak/report/:id/:uuid' exact component={AkhlakReport}/>
            <Route path='/akhlak/reportall' exact component={AkhlakReportAll}/>
            <Route path='/organitationassessment/:uuid' exact component={AuditDesktop}/>
            <Route path='/survey/report/:id/:uuid' exact component={Report}/>

            <Route path='/kepemimpinan' exact component={Kepemimpinan}/>
            <Route path='/kepemimpinan/report/:id/:uuid' exact component={KepemimpinanReport}/>
            <Route path='/kepemimpinan/report2/:id/:uuid' exact component={KepemimpinanReport2}/>

            <Route path='/publication/cataloge' exact component={Catalouge}/>
            
            <Route path='/edtra' exact component={NewDtra}/>
            <Route path='/edtra/link' exact component={ListLink}/>
            <Route path='/edtra/link/:uuid' exact component={NewDtra}/>
            <Route path='/edtra/report/:uuid' exact component={ReportEdtra}/>

          </Switch>
      </Router>
    )
}
